import { IService, ServiceType } from "./ServiceManager";
import { Logger, LogLevel } from "./Logger";

interface IBrowserStorageProvider {
  setItem(key: string, value: any): void;
  getItem(key: string): any;
}

interface BrowserStorageDictionary {
  [key: string]: string;
}

class BrowserStorageFallback implements IBrowserStorageProvider {
  private items: BrowserStorageDictionary = {};

  setItem(key: string, value: any): void {
    this.items[key] = value;
  }

  getItem(key: string) {
    return this.items[key];
  }
}

class BrowserStorageService implements IService, IBrowserStorageProvider {
  Type: ServiceType = ServiceType.BrowserStorage;
  Id: string = 'BrowserStorageService';
  private Provider: IBrowserStorageProvider;

  constructor() {
    if('localStorage' in window) {
      this.Provider = window.localStorage;
    } else if('sessionStorage' in window) {
      this.Provider = window.sessionStorage;
    } else {
      Logger.Log(LogLevel.Warning, `[${this.Id}]`, 'Using BrowserStorageFallback');
      this.Provider = new BrowserStorageFallback();
    }
  }

  getItem(key: string) {
    return this.Provider.getItem(key);
  }

  setItem(key: string, value: any) {
    this.Provider.setItem(key, value);
  }
}

export { BrowserStorageService, IBrowserStorageProvider }
